module.exports = "https://static.energy5.com/_next/static/images/slide03-e1e5e7f6e7b2abe4badb0497dafab6b2.webp";